import Emphasis from './Emphasis';

export default Emphasis;
